export default {
      id: "Icon--pause-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--pause",
      toString: function () {
        return this.url;
      }
    }